import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { SmsService } from 'src/app/services/sms-service/smsservice';
import { Subscription } from 'rxjs';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-sms-smss-dashboard',
  templateUrl: './sms-smss-dashboard.component.html',
  styleUrls: ['./sms-smss-dashboard.component.scss']
})
export class SmsSmssDashboardComponent implements OnInit, OnDestroy {

  smss;
  filterKey;
  filterOpts;
  noItemsConfig;
  viewDisposition = 'grid';
  getSMSsSubscription: Subscription;
  searchSmsSubscription: Subscription;
  filterSmsSubscription: Subscription;
  toggleSmssDispositionSubscription: Subscription;

  constructor(private smsDesksTurnsService: SmsService,
              private snackbarService: SnackBarService,
              private userStorageService: UserStorageService,
              private cd: ChangeDetectorRef,
              private headerBreadcrumbService: HeaderBreadcrumbService) {
                this.noItemsConfig = this.setNoItemsConfig();
              }

  ngOnInit() {
    this.setBreadcrumb();
    this.getSMSs();
    this.smsDesksTurnsService.refreshSmsListListen().subscribe(
      (res) => {
        this.getSMSs();
      }
    );
    this.filterSmsSubscription = this.smsDesksTurnsService.filterSmsListen().subscribe(
      (res) => {
        this.filterOpts = res;
        this.cd.detectChanges();
      }
    );
    this.searchSmsSubscription = this.smsDesksTurnsService.searchSmsListen().subscribe(
      (res) => {
        this.filterKey = res;
      }
    );
    this.toggleSmssDispositionSubscription = this.smsDesksTurnsService.toggleSmssDispositionListen().subscribe(
      (res) => {
        this.viewDisposition = res;
      }
    );
  }

  private getSMSs() {
    this.getSMSsSubscription = this.smsDesksTurnsService.getSmsList().subscribe(
      (res) => {
       this.smss = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-sms', 'sms-page.smss', '/account', [new BRoute('account-page.account', '/account'), new BRoute('sms-page.smss')]));
  }

  private setNoItemsConfig() {
    return {
      description: 'sms-page.smss not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngOnDestroy() {
    if (this.getSMSsSubscription) { this.getSMSsSubscription.unsubscribe(); }
    if (this.searchSmsSubscription) { this.searchSmsSubscription.unsubscribe(); }
    if (this.filterSmsSubscription) { this.filterSmsSubscription.unsubscribe(); }
    if (this.toggleSmssDispositionSubscription) { this.toggleSmssDispositionSubscription.unsubscribe(); }
  }

}
